export default function SafetySection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-widest mb-3">
              Sicurezza
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-5">
              Itaobuy &egrave; sicuro?
            </h2>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-6">
              Prima di acquistare online &egrave; importante verificare informazioni prodotto, qualit&agrave;, recensioni e utilizzare metodi di pagamento affidabili. Con l&apos;<strong>itaobuy spreadsheet</strong> puoi fare tutto questo in modo organizzato.
            </p>

            <div className="space-y-3">
              {[
                { label: 'Foto QC', stars: 5, desc: 'Essenziali per verificare la qualit\u00e0 reale' },
                { label: 'Informazioni prodotto', stars: 5, desc: 'Dati completi per ogni articolo' },
                { label: 'Recensioni', stars: 4, desc: 'Feedback da altri acquirenti' },
                { label: 'Metodo pagamento', stars: 5, desc: 'Scegli sempre opzioni sicure' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-4 p-4 rounded-xl bg-background-100">
                  <div className="flex items-center gap-0.5 min-w-[100px]">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm ${i < item.stars ? 'text-accent-500' : 'text-background-300'}`}
                      ></i>
                    ))}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">{item.label}</p>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20organized%20workspace%20with%20product%20verification%20checklist%20on%20tablet%20next%20to%20fashion%20item%20with%20inspection%20tags%20warm%20ambient%20lighting%20from%20desk%20lamp%20soft%20cream%20wall%20background%20professional%20quality%20control%20concept%20editorial%20photography%20minimal%20aesthetic&width=700&height=500&seq=safety-img-002&orientation=landscape&nocache=true"
                alt="Itaobuy Spreadsheet - Sicurezza acquisti"
                title="Itaobuy Spreadsheet sicuro"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}